import React from "react";
import { useTranslation } from "react-i18next";
import { DataTableFilter } from "@/components/controls/DataTableFilters/DataTableFilters";
import { Filters, FiltersSetter } from "@/services/api/types";
import FilterSubmenu from "./FilterSubmenu";
import FilterDateSubmenu from "./FilterDateSubmenu";
import FilterNumericSubmenu from "./FilterNumericSubmenu";
import FilterCustomFieldSubmenu from "./FilterCustomFieldSubmenu";
import FilterBooleanSubmenu from "./FilterBooleanSubmenu";
import FilterTextSubmenu from "./FilterTextSubmenu";

interface Props {
  filterOption: DataTableFilter;
  filters: Filters;
  setFilters: FiltersSetter;
  onClose?: () => void;
  filterLabel?: string;
}

const FilterContent: React.FC<Props> = ({
  filterOption,
  filters,
  setFilters,
  onClose,
  filterLabel
}) => {
  const { t } = useTranslation();

  const isDateFilter = filterOption.filterType.type === "date";
  const isNumericFilter = filterOption.filterType.type === "numeric";
  const isCustomFieldFilter = filterOption.filterType.type === "customField";
  const isBooleanFilter = filterOption.filterType.type === "boolean";
  const isTextFilter = filterOption.filterType.type === "text";

  const label =
    filterLabel ??
    t(`datatoolbar.filters.sortAndGroupByOptions.${filterOption.key}`);

  if (isDateFilter) {
    return (
      <FilterDateSubmenu
        filterOption={filterOption}
        filters={filters}
        setFilters={setFilters}
      />
    );
  }

  if (isNumericFilter) {
    return (
      <FilterNumericSubmenu
        filterOption={filterOption}
        filterLabel={label}
        filters={filters}
        setFilters={setFilters}
        onClose={onClose}
      />
    );
  }

  if (isCustomFieldFilter) {
    return (
      <FilterCustomFieldSubmenu
        filterOption={filterOption}
        filters={filters}
        setFilters={setFilters}
        onClose={onClose}
      />
    );
  }

  if (isBooleanFilter) {
    return (
      <FilterBooleanSubmenu
        filterOption={filterOption}
        filters={filters}
        setFilters={setFilters}
        onClose={onClose}
      />
    );
  }

  if (isTextFilter) {
    return (
      <FilterTextSubmenu
        filterOption={filterOption}
        filterLabel={label}
        filters={filters}
        setFilters={setFilters}
        onClose={onClose}
      />
    );
  }

  return (
    <FilterSubmenu
      filterOption={filterOption}
      filters={filters}
      setFilters={setFilters}
      onClose={onClose}
    />
  );
};

export default FilterContent;
